// src/featureFlags.js

const featureFlags = {
    showProgressTracker: false,
  };
  
  export const getFeatureFlag = (flagName) => {
    return featureFlags[flagName] || false;
  };